// extracted by css-extract-rspack-plugin
export default {"container":"xLzHV","gridWrapper":"_bBMD","gridFooter":"mqSsA","filtersSection":"Mxyxm"};